import { rem } from 'polished';
import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import AnimateHeight from 'react-animate-height';
import styled from 'styled-components';
import IconLazy from '../../components/_helpers/Icon/IconLazy';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => rem(theme.borderRadius.default)};
  box-shadow: ${({ theme }) => theme.boxShadow.small};
  margin-top: ${rem(15)};
  margin-bottom: ${rem(15)};
`;

const Header = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: ${rem(16)};
  text-align: left;
  padding: ${rem(15)} ${rem(20)};
  outline: none;
`;

const Chevron = styled(IconLazy)`
  ${({ theme }) => theme.size(12)};
  ${({ theme }) => theme.transition('transform')};
  &.active {
    transform: rotate(180deg);
  }
`;

const Body = styled.div`
  font-size: ${rem(14)};
  line-height: 1.6;
  padding: 0 ${rem(20)} ${rem(20)};
  white-space: pre-line;
`;

export interface ProductManufacturerProps {
  manufacturer: { id?: number; name?: string; detail?: string } | null;
}

export const ProductManufacturer = (props: ProductManufacturerProps) => {
  const { manufacturer } = props;
  const [open, setOpen] = React.useState(false);

  if (!manufacturer || !manufacturer.detail) {
    return null;
  }

  return (
    <Wrapper>
      <Header type="button" onClick={() => setOpen(!open)}>
        {__('Výrobca/Distribútor')}
        <Chevron icon="chevron" className={open ? 'active' : ''} />
      </Header>
      <AnimateHeight height={open ? 'auto' : 0}>
        <Body dangerouslySetInnerHTML={{ __html: manufacturer.detail }} />
      </AnimateHeight>
    </Wrapper>
  );
};

export default ProductManufacturer;
